import { ReactNode } from 'react'
import { CircleAlert, CircleCheck, Info } from 'lucide-react'

type Tipo = 'info' | 'success' | 'error'
const ICONO = { info: Info, success: CircleCheck, error: CircleAlert }

/** Alerta del kit. Los errores se anuncian de inmediato (role="alert"); el resto, con cortesía. */
export function Alerta({ tipo = 'info', titulo, children }: { tipo?: Tipo; titulo?: string; children?: ReactNode }) {
  const Icono = ICONO[tipo]
  return (
    <div className={`dcc-alert dcc-alert--${tipo}`} role={tipo === 'error' ? 'alert' : 'status'}>
      <Icono className="dcc-icon dcc-i" aria-hidden />
      <span className="dcc-stack">
        {titulo && <strong>{titulo}</strong>}
        {children && <span>{children}</span>}
      </span>
    </div>
  )
}
